var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { md: "6", "offset-md": "3" } },
        [
          _c(
            "b-card",
            {
              staticClass: "user-form",
              attrs: {
                "header-class": "bg-primary",
                "footer-class": "card-footer-between"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "user-form-header",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [
                  _vm.editUser
                    ? _c("span", { staticClass: "text-uppercase" }, [
                        _c("strong", [_vm._v(_vm._s(_vm.$t("COMMON.EDIT")))]),
                        _c("strong", [
                          _vm._v(" " + _vm._s(_vm.$t("COMMON.USERS")))
                        ])
                      ])
                    : _c("span", { staticClass: "text-uppercase" }, [
                        _c("strong", [_vm._v(_vm._s(_vm.$t("USERS.ADD_NEW")))])
                      ])
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { sm: "12" } },
                [
                  _c(
                    "b-form-group",
                    [
                      _c("label", { attrs: { for: "name" } }, [
                        _vm._v(_vm._s(_vm.$t("COMMON.NAME")))
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.user.username,
                            expression: "user.username"
                          }
                        ],
                        staticClass: "form-control",
                        class: {
                          "is-invalid": _vm.$v.user.username.$error,
                          "is-valid": !_vm.$v.user.username.$invalid
                        },
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t("COMMON.NAME")
                        },
                        domProps: { value: _vm.user.username },
                        on: {
                          blur: function($event) {
                            _vm.$v.user.username.$touch()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.user, "username", $event.target.value)
                          }
                        }
                      }),
                      _vm._v(" "),
                      !_vm.$v.user.username.required
                        ? _c("b-form-invalid-feedback", [
                            _vm._v(_vm._s(_vm.$t("USERS.REQ_USERNAME")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.user.username.alphaNum
                        ? _c("b-form-invalid-feedback", [
                            _vm._v(_vm._s(_vm.$t("USERS.REQ_ONLY_ALPHANUM")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.user.username.minLen
                        ? _c("b-form-invalid-feedback", [
                            _vm._v(_vm._s(_vm.$t("USERS.REQ_MIN_LENGTH")))
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c("label", { attrs: { for: "name" } }, [
                    _vm._v(_vm._s(_vm.$t("USERS.EMAIL")))
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.email,
                        expression: "user.email"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.$v.user.email.$error,
                      "is-valid": !_vm.$v.user.email.$invalid
                    },
                    attrs: {
                      type: "email",
                      placeholder: _vm.$t("USERS.EMAIL")
                    },
                    domProps: { value: _vm.user.email },
                    on: {
                      blur: function($event) {
                        _vm.$v.user.email.$touch()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.user, "email", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  !_vm.$v.user.email.required
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(_vm._s(_vm.$t("USERS.REQ_EMAIL")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.user.email.email
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(" " + _vm._s(_vm.$t("USERS.REQ_VALID_EMAIL")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.editUser
                ? _c("b-form-group", [
                    _c("label", { attrs: { for: "name" } }, [
                      _vm._v(_vm._s(_vm.$t("COMMON.STATUS")) + " ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: { color: "blue", "font-style": "italic" }
                      },
                      [
                        _vm._v(
                          " * Deactivated users will be activated with update. "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "form-control",
                      attrs: { type: "text", value: "ACTIVE", disabled: "" }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isSuperAdmin
                ? _c(
                    "b-form-group",
                    [
                      _c("label", { attrs: { for: "name" } }, [
                        _vm._v(_vm._s(_vm.$t("COMMON.ACCOUNT")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form-select",
                        {
                          class: {
                            "is-invalid": _vm.$v.user.account_id.$error,
                            "is-valid": !_vm.$v.user.account_id.$invalid
                          },
                          attrs: { plain: true },
                          model: {
                            value: _vm.user.account_id,
                            callback: function($$v) {
                              _vm.$set(_vm.user, "account_id", $$v)
                            },
                            expression: "user.account_id"
                          }
                        },
                        [
                          _c("template", { slot: "first" }, [
                            _c(
                              "option",
                              { attrs: { value: "", disabled: true } },
                              [_vm._v(" Please select an account ")]
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.accounts, function(account) {
                            return _c(
                              "option",
                              { domProps: { value: account.id } },
                              [
                                _vm._v(
                                  _vm._s(_vm._f("capitalize")(account.name))
                                )
                              ]
                            )
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      !_vm.$v.user.account_id.required
                        ? _c("b-form-invalid-feedback", [
                            _vm._v(_vm._s(_vm.$t("USERS.REQ_ACCOUNT")))
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c("label", { attrs: { for: "name" } }, [
                    _vm._v(_vm._s(_vm.$t("USERS.ROLE")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-select",
                    {
                      class: {
                        "is-invalid": _vm.$v.user.role_id.$error,
                        "is-valid": !_vm.$v.user.role_id.$invalid
                      },
                      attrs: { plain: true },
                      model: {
                        value: _vm.user.role_id,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "role_id", $$v)
                        },
                        expression: "user.role_id"
                      }
                    },
                    [
                      _c("template", { slot: "first" }, [
                        _c("option", { attrs: { value: "", disabled: true } }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("USERS.SELECT_ROLE")) + " "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.roles, function(role) {
                        return _c("option", { domProps: { value: role.id } }, [
                          _vm._v(_vm._s(_vm._f("capitalize")(role.name)))
                        ])
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.roles.length === 0
                    ? _c("div", { staticClass: "error-message" }, [
                        _vm._v(_vm._s(_vm.$t("USERS.CREATE_ROLE")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.$v.user.role_id.required
                    ? _c("b-form-invalid-feedback", [
                        _vm._v(_vm._s(_vm.$t("USERS.REQ_ROLE")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.teams.length > 0 && _vm.isAdmin
                ? _c(
                    "b-form-group",
                    [
                      _c("label", { attrs: { for: "name" } }, [
                        _vm._v(_vm._s(_vm.$t("USERS.TEAM")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form-select",
                        {
                          attrs: { plain: true },
                          model: {
                            value: _vm.user.team_id,
                            callback: function($$v) {
                              _vm.$set(_vm.user, "team_id", $$v)
                            },
                            expression: "user.team_id"
                          }
                        },
                        [
                          _c("template", { slot: "first" }, [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(_vm._s(_vm.$t("USERS.SELECT_TEAM")))
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.teams, function(team) {
                            return _c(
                              "option",
                              { domProps: { value: team.id } },
                              [_vm._v(_vm._s(_vm._f("capitalize")(team.name)))]
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "settings-block" }, [
                !_vm.editUser
                  ? _c(
                      "div",
                      { staticClass: "settings-container" },
                      [
                        _c("p", [
                          _vm._v(_vm._s(_vm.$t("PROFILE.EMAIL_NOTIFY")))
                        ]),
                        _vm._v(" "),
                        _c("c-switch", {
                          attrs: {
                            type: "3d",
                            variant: "success",
                            checked: this.user.notify
                          },
                          on: { change: _vm.pSwitchChanged }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "b-button",
                {
                  staticClass: "padding-x-2",
                  attrs: { type: "submit", size: "sm", variant: "secondary" },
                  on: {
                    click: function($event) {
                      _vm.formSubmit()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-dot-circle-o" }),
                  _vm._v(" " + _vm._s(_vm.$t("COMMON.SUBMIT")))
                ]
              ),
              _vm._v(" "),
              this.editUser
                ? _c(
                    "b-button",
                    {
                      staticClass: "padding-x-2",
                      attrs: { type: "reset", size: "sm", variant: "gray" },
                      on: {
                        click: function($event) {
                          _vm.cancelForm()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-ban" }), _vm._v(" Cancel")]
                  )
                : _c(
                    "b-button",
                    {
                      staticClass: "padding-x-2",
                      attrs: { type: "reset", size: "sm", variant: "gray" },
                      on: {
                        click: function($event) {
                          _vm.resetForm()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-ban" }),
                      _vm._v(" " + _vm._s(_vm.$t("COMMON.RESET")))
                    ]
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b2730f02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2730f02","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/userForm.vue
// module id = 1301
// module chunks = 2